<template>
	<LayoutFlex
		background="--background-white"
		corner-radius="var(--size-24)"
		padding="var(--size-24)"
		gap="var(--size-8)"
	>
		<Text font="--text-16-22-semi" color="--text-dark-primary">Coming soon</Text>
		<Text font="--text-16-22-reg" color="--text-dark-secondary">This section is on its way.</Text>
	</LayoutFlex>
</template>

<script setup lang="ts">
import { LayoutFlex, Text } from '@simple-life-app/growth-ui-kova'

/**
 * Clearly temporary content for a section whose feature work has not landed (KOVA-796 "First
 * deliverable"). Customer-facing, so no ticket keys: the view that renders it names its ticket in a
 * comment. The feature branch replaces it; nothing else depends on it.
 */
</script>
